import {VersionVariants} from '@jobseeker/lotus/enums';
import {PropTypes} from './type';
import NotImplemented from '@jobseeker/lotus/elements/NotImplemented';
import V2 from './V2';
const componentMap: any = {};
componentMap[VersionVariants.VERSION_ONE] = NotImplemented;
componentMap[VersionVariants.VERSION_TWO] = V2;
componentMap[VersionVariants.VERSION_THREE] = NotImplemented;

const CTA = (props: PropTypes) => {
  let Component;
  if (Object.keys(componentMap).includes(props.variant)) {
    Component = componentMap[props.variant];
  } else {
    Component = componentMap[VersionVariants.VERSION_ONE];
  }
  return <Component {...props} />;
};

export default CTA;
